import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Col, Row } from 'reactstrap';
import Translate from '../i18n/Translate';

const propTypes = {
  errorType: PropTypes.string,
};

const defaultProps = {
  errorType: '',
};

const ErrorAlert = ({ errorType }) => (
  errorType ? (
    <Row className="mt-2 mb-0 form-group">
      <Col>
        <Alert color="danger mb-0">
          <Translate translationKey={errorType} />
        </Alert>
      </Col>
    </Row>
  ) : null
);

ErrorAlert.propTypes = propTypes;
ErrorAlert.defaultProps = defaultProps;


export default ErrorAlert;
